module.exports = __webpack_public_path__ + "img/credit-card.9077d784.svg";